import type { PropsWithChildren } from "react";
import { CssBaseline } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes } from "react-router-dom";

import ErrorBoundary from "~/Components/ErrorBoundary";
import Layout from "~/Components/Layout";
import ThemeProvider from "~/Components/Theme/ThemeProvider";
import ToastContainer from "~/Components/ToastContainer";
import Search from "~/Pages/Search";
import Section from "~/Pages/Section";

interface AppShellProps extends PropsWithChildren {
    helmetContext?: Record<string, unknown>;
}

export const AppShell = ({ children, helmetContext }: AppShellProps) => (
    <ThemeProvider>
        <CssBaseline />
        <ErrorBoundary>
            <ToastContainer />
            <HelmetProvider context={helmetContext}>{children}</HelmetProvider>
        </ErrorBoundary>
    </ThemeProvider>
);

export const AppRoutes = () => (
    <Routes>
        <Route path="/" element={<Layout />}>
            <Route index element={<Section />} />
            <Route path="/search" element={<Search />} />
            <Route path="*" element={<Section />} />
        </Route>
    </Routes>
);
